import React from "react"

function IconArrowDownLeft({ color = "currentColor", color2, fontSize, height, ...props }) {
  return (
    <svg
      fill={color}
      fuze-icon="arrow-down-left"
      viewBox="0 0 24 24"
      style={{ height: height || fontSize }}
      originalclass="fz-icon fz-icon-arrow-down-left"
      {...props}
    >
      <path
        d="M6.948 17.29a.655.655 0 0 1-.646-.547l-.009-.107v-6.35a.655.655 0 0 1 1.3-.107l.01.106v4.77l8.571-8.571a.655.655 0 0 1 1.001.835l-.075.09-8.573 8.574 4.772-.001c.325 0 .595.237.646.548l.009.106a.655.655 0 0 1-.549.646l-.106.009H6.948z"
        fill={color}
        fillRule="evenodd"
        style={{ height: height || fontSize }}
        originalclass="__primary"
      />
    </svg>
  )
}

export default IconArrowDownLeft
